const RESIZE_OBSERVER_LOOP_MESSAGES = [
  'ResizeObserver loop completed with undelivered notifications.',
  'ResizeObserver loop limit exceeded',
]

/** CRA/webpack dev overlay treats this browser quirk as a fatal error. */
export const suppressResizeObserverLoopError = () => {
  if (typeof window === 'undefined') return

  const onError = (event) => {
    const message = event?.message || event?.reason?.message || ''
    if (!RESIZE_OBSERVER_LOOP_MESSAGES.some((m) => message.includes(m))) {
      return
    }
    event.stopImmediatePropagation?.()
  }

  window.addEventListener('error', onError)
}
